import { CdkScrollable } from "@angular/cdk/scrolling";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { RouterLink } from "@angular/router";

import { RoleGuardConfig } from "src/modules/app/guards/role.guard";
import { UserStateService } from "src/shared/services/user-state.service";

import { TranslatePipe } from "../../../shared/i18n/translate.pipe";

export type MissingRoleDialogInput = RoleGuardConfig & { returnUrl: string };

@Component({
  selector: "app-missing-role-dialog",
  templateUrl: "./missing-role-dialog.component.html",
  styleUrls: ["./missing-role-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, CdkScrollable, MatButton, RouterLink, MatIcon, TranslatePipe],
})
export class MissingRoleDialogComponent {
  readonly data = inject<MissingRoleDialogInput>(MAT_DIALOG_DATA);
  private readonly userStateService = inject(UserStateService);

  get rolesRequired(): string {
    const roles = this.data?.roleGuardConfig?.roles ?? {};
    const some = roles.some ? [`(${roles.some.join(" | ")})`] : [];
    const every = roles.every ? [`(${roles.every.join(" & ")})`] : [];
    return [...some, ...every].join(" & ");
  }

  onGotoLogin() {
    this.userStateService.gotoLogin();
  }
}
